/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RelatedEntityAdjustment } from './RelatedEntityAdjustment';
export type WaterfallView = {
  readonly id?: number;
  company: number;
  name: string;
  measurement_date?: number | null;
  readonly measurement_date_value?: string;
  cap_table?: number | null;
  exit_date?: string | null;
  exit_equity_value?: string | null;
  exit_enterprise_value?: string | null;
  plus_cash?: string | null;
  less_debt?: string | null;
  related_entity_adjustments?: Record<string, RelatedEntityAdjustment>;
  foreign_currency?: string;
  currency_format?: WaterfallView.currency_format;
  foreign_exchange_rate?: string | null;
  foreign_exchange_rate_is_overridden?: boolean;
  foreign_exchange_rate_input_currency?: WaterfallView.foreign_exchange_rate_input_currency;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace WaterfallView {
  export enum currency_format {
    REGULAR = 'regular',
    THOUSANDS = 'thousands',
    MILLIONS = 'millions',
  }
  export enum foreign_exchange_rate_input_currency {
    BASE = 'base',
    FOREIGN = 'foreign',
  }
}

